import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import Sidebar from '../../components/shared/Sidebar';
import { FiUsers, FiCheckCircle, FiAlertCircle, FiXCircle, FiCalendar, FiDollarSign } from 'react-icons/fi';

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [pwForm, setPwForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [pwSaving, setPwSaving] = useState(false);
  const [settings, setSettings] = useState({ whatsapp_number: '', contact_email: '' });
  const [setSaving, setSetSaving] = useState(false);
  const handleSettingsSave = async () => {
    setSetSaving(true);
    try {
      await axios.put('/api/admin/settings', { whatsapp_number: settings.whatsapp_number, contact_email: settings.contact_email });
      toast.success('Settings save ho gayi!');
    } catch { toast.error('Error'); }
    setSetSaving(false);
  };
  const handleChangePassword = async () => {
    if (pwForm.newPassword.length < 6) { toast.error('Naya password kam se kam 6 characters ka ho'); return; }
    if (pwForm.newPassword !== pwForm.confirmPassword) { toast.error('Naya password aur confirm match nahi karte'); return; }
    setPwSaving(true);
    try {
      await axios.put('/api/auth/change-password', { currentPassword: pwForm.currentPassword, newPassword: pwForm.newPassword });
      toast.success('Password change ho gaya!');
      setPwForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
    } catch (err) {
      toast.error(err.response?.data?.message || 'Error');
    }
    setPwSaving(false);
  };

  useEffect(() => {
    axios.get('/api/admin/settings').then(r => setSettings({ whatsapp_number: r.data.whatsapp_number || '', contact_email: r.data.contact_email || '' })).catch(() => {});
    axios.get('/api/admin/dashboard').then(r => { setStats(r.data); setLoading(false); });
  }, []);

  const statCards = stats ? [
    { label: 'Total Shops', value: stats.totalShops, icon: FiUsers, color: '#6c5ce7' },
    { label: 'Active Shops', value: stats.activeShops, icon: FiCheckCircle, color: 'var(--success)' },
    { label: 'Expired', value: stats.expiredShops, icon: FiAlertCircle, color: 'var(--gold)' },
    { label: 'Suspended', value: stats.suspendedShops, icon: FiXCircle, color: 'var(--danger)' },
    { label: 'Total Bookings', value: stats.totalBookings, icon: FiCalendar, color: 'var(--accent)' },
    { label: 'This Month Revenue', value: `PKR ${Number(stats.monthlyRevenue).toLocaleString()}`, icon: FiDollarSign, color: 'var(--success)' },
  ] : [];

  return (
    <div className="app-layout">
      <Sidebar />
      <div className="main-content">
        <div className="page-header">
          <h1>Dashboard</h1>
          <p>Platform ka overview</p>
        </div>

        {loading ? <div className="spinner" style={{ margin: '40px auto' }} /> : (
          <>
            <div className="grid-3" style={{ marginBottom: '28px' }}>
              {statCards.map((s, i) => (
                <div key={i} className="stat-card" style={{ borderLeft: `4px solid ${s.color}` }}>
                  <div className="flex-between">
                    <div>
                      <div className="stat-value">{s.value}</div>
                      <div className="stat-label">{s.label}</div>
                    </div>
                    <s.icon size={32} color={s.color} />
                  </div>
                </div>
              ))}
            </div>

            {stats.expiringShops?.length > 0 && (
              <div className="card">
                <div className="flex-between mb-4">
                  <h3 style={{ color: 'var(--gold)' }}>⚠️ 7 Din Mein Expire Hone Wali Shops</h3>
                </div>
                <div className="table-wrapper">
                  <table>
                    <thead>
                      <tr><th>Shop Name</th><th>Owner</th><th>Phone</th><th>Expiry Date</th></tr>
                    </thead>
                    <tbody>
                      {stats.expiringShops.map((shop, i) => (
                        <tr key={i}>
                          <td>{shop.shop_name}</td>
                          <td>{shop.owner_name}</td>
                          <td>{shop.phone}</td>
                          <td><span className="badge badge-warning">{new Date(shop.subscription_end).toLocaleDateString('en-PK')}</span></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            <div className="card mt-4">
              <h3 style={{ marginBottom: '16px' }}>🚀 Quick Actions</h3>
              <div className="flex gap-3" style={{ flexWrap: 'wrap' }}>
                <a href="/admin/shops/add" className="btn btn-primary">+ Naya Shop Add Karein</a>
                <a href="/admin/plans" className="btn btn-secondary">📦 Plans Manage Karein</a>
                <a href="/admin/shops" className="btn btn-outline">👥 Sab Shops Dekhein</a>
              </div>
            </div>
            <div className="card mt-4" style={{ maxWidth: '500px' }}>
              <h3 style={{ marginBottom: '16px' }}>🔒 Password Change Karein</h3>
              <div className="form-group">
                <label className="form-label">Purana Password</label>
                <input type="password" className="form-control" value={pwForm.currentPassword} onChange={e => setPwForm({ ...pwForm, currentPassword: e.target.value })} />
              </div>
              <div className="form-group">
                <label className="form-label">Naya Password</label>
                <input type="password" className="form-control" value={pwForm.newPassword} onChange={e => setPwForm({ ...pwForm, newPassword: e.target.value })} placeholder="Min 6 characters" />
              </div>
              <div className="form-group">
                <label className="form-label">Naya Password Dobara</label>
                <input type="password" className="form-control" value={pwForm.confirmPassword} onChange={e => setPwForm({ ...pwForm, confirmPassword: e.target.value })} />
              </div>
              <button className="btn btn-primary" onClick={handleChangePassword} disabled={pwSaving}>{pwSaving ? 'Change ho raha hai...' : '🔒 Password Change Karein'}</button>
            </div>
            <div className="card mt-4" style={{ maxWidth: '500px' }}>
              <h3 style={{ marginBottom: '8px' }}>📱 Contact Settings</h3>
              <p style={{ color: 'var(--text-light)', fontSize: '13px', marginBottom: '16px' }}>Ye WhatsApp number aur email landing page par order/rabta ke liye dikhega. Number country code ke saath (bina + ya 0), jaise 923001234567</p>
              <div className="form-group">
                <label className="form-label">WhatsApp Number (order ke liye)</label>
                <input className="form-control" value={settings.whatsapp_number} onChange={e => setSettings({ ...settings, whatsapp_number: e.target.value })} placeholder="923001234567" />
              </div>
              <div className="form-group">
                <label className="form-label">Contact Email</label>
                <input className="form-control" value={settings.contact_email} onChange={e => setSettings({ ...settings, contact_email: e.target.value })} placeholder="example@gmail.com" />
              </div>
              <button className="btn btn-primary" onClick={handleSettingsSave} disabled={setSaving}>{setSaving ? 'Saving...' : '💾 Settings Save Karein'}</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
